import React from 'react';
import BackButton from '../BackButton';

function RegularHeader({ headerTitle }) {
    return (
        <>
            <header className="section-t-space">
                <div className="custom-container">
                    <div className="header-panel">
                        <BackButton />
                        <h2>{headerTitle}</h2>

                        {/*            <div className="dropdown">*/}
                        {/*                <Link to="#" className="back-btn" role="button" data-bs-toggle="dropdown">*/}
                        {/*                    <i className="icon" data-feather="settings"></i>*/}
                        {/*                </Link>*/}

                        {/*                <ul className="dropdown-menu">*/}
                        {/*                    <li><Link className="dropdown-item" to="" onClick={handleThisMonth}>This Months</Link>*/}
                        {/*                    </li>*/}
                        {/*                    <li><Link to="#" onClick={handlePrevMonth} className="dropdown-item">Last Month</Link>*/}
                        {/*                    </li>*/}
                        {/*                    <li><Link className="dropdown-item" to="#period" data-bs-toggle="modal">Custom</Link>*/}
                        {/*                    </li>*/}
                        {/*                </ul>*/}
                        {/*            </div>*/}
                    </div>
                </div>
            </header>
        </>
    );
}

export default RegularHeader;
